import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";

import { useDeleteComment } from "../../api/deleteComment";

export default function DeleteComment({ postId, commentId, children }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const openDialog = () => {
    setDialogOpen(true);
  };
  const closeDialog = () => {
    setDialogOpen(false);
  };
  const deleteCommentM = useDeleteComment({
    postId,
    commentId,
  });

  const confirmDeletion = () => {
    deleteCommentM.mutate(null, {
      onSuccess: () => {
        closeDialog();
      },
    });
  };

  const methods = {
    openDialog,
  };
  return (
    <>
      {children(methods)}
      <Dialog open={dialogOpen} maxWidth="xs" fullWidth onClose={closeDialog}>
        <DialogTitle>Deletar comentário</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Você tem certeza que deseja deletar este comentário
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>cancelar</Button>
          <Button onClick={confirmDeletion} variant="contained">
            Deletar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
